import { OptionDescription } from './option.type';
import { EVerifyStatus } from '../enums/verify.enum';

export type VerifyStatusRecord = Record<EVerifyStatus, OptionDescription<EVerifyStatus> & { viewClass: string }>;
